import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { systemHubCards } from "../../navigation/appNavigation";
import { SectionLabels } from "../../utils/navigation/pageTitles";

const SystemHubPage = () => (
    <SectionHubPage title={SectionLabels.system} cards={systemHubCards} />
);

export { SystemHubPage };
